<!-- 将 Lottery 包一层来添加设置 -->
<template>
  <LotteryPanel
    :isShowLeftChance="false"
    :isShowBroadcast="false"
    v-bind="$attrs"
    v-on="$listeners"
  />
</template>

<script>
import LotteryPanel from './LotteryPanel.vue';

export default {
  components: { LotteryPanel }
};
</script>
